function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.4 3.6a1.2 1.2 0 011.2-1.2h1.6a1.2 1.2 0 011.2 1.2v1.6a1.2 1.2 0 01-1.2 1.2h-.4v3.073c.06.034.115.077.166.127L6.4 11.035a.8.8 0 01.128.165H9.6v-.4a1.2 1.2 0 011.2-1.2h1.6a1.2 1.2 0 011.2 1.2v1.6a1.2 1.2 0 01-1.2 1.2h-1.6a1.2 1.2 0 01-1.2-1.2V12H6.528a.8.8 0 01-.128.166L4.966 13.6a.8.8 0 01-1.131 0L2.4 12.166a.8.8 0 010-1.131L3.835 9.6A.801.801 0 014 9.473V6.4h-.4a1.2 1.2 0 01-1.2-1.2V3.6z",
  fill: "#8F90A6"
});

function SvgLifecycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecycle;